export { FilterMenuReact } from './src/filter-menu-react';
